<template>
  <v-card class="mx-auto" max-width="1280" variant="Tonal">
    <v-list :items="items" item-props lines="three">
      <template v-slot:subtitle="{ subtitle }">
        <div v-html="subtitle" class="subtitle_text"></div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
  export default {
    data: () => ({
      items: [
        {
          title: "2023/8/23",
          subtitle: `開催情報に会場マップを追加しました。`,
        },
        //↓仕切りボーダー
        {
          type: "divider",
          color: "green",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2023/8/21",
          subtitle: `出展タイトルと当日イベントを更新しました。`,
        },
        //↓仕切りボーダー
        {
          type: "divider",
          color: "green",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2023/8/1",
          subtitle: `ふしぎなゲーム祭り公式サイトオープン！`,
        },
        //↓仕切りボーダー
        {
          type: "divider",
          color: "green",
          class: "border-opacity-50",
          thickness: "2",
        },
      ],
    }),
  };
</script>

<style scoped>
  .subtitle_text {
    font-size: 1.2em;
    line-height: 2em;
  }
</style>
